/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Personalityhumorstylesoutheast4Inputs */



/**
* | output |
* | --- |
* | "Soft Self-Roaster" |
*
* @param {Personalityhumorstylesoutheast4Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const personalityhumorstylesoutheast4 = /** @type {((inputs?: Personalityhumorstylesoutheast4Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Personalityhumorstylesoutheast4Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Soft Self-Roaster")
	if (locale === "es") return /** @type {LocalizedString} */ ("Autoironista suave")
	return /** @type {LocalizedString} */ ("Мягкий самоиронщик")
});
export { personalityhumorstylesoutheast4 as "personalityHumorStyleSouthEast" }